'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  POSITION: {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    TOP_CENTER: 'top-center',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_CENTER: 'bottom-center'
  },
  TYPE: {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'default'
  },
  ACTION: {
    SHOW: 'SHOW_TOAST',
    CLEAR: 'CLEAR_TOAST',
    MOUNTED: 'CONTAINER_MOUNTED'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-toastify/lib/config.js
// module id = ./node_modules/react-toastify/lib/config.js
// module chunks = 114276838955818 137591856104208 276150767547794